import React, { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Wrapper, Title, Container } from './styled';

const DateInput = ({ onChange, title, value, required }) => {
  const [inputValue, setInputValue] = useState(value);

  const handleChange = (date) => {
    if (date) {
      const formattedDate = date.toISOString().split('T')[0];
      setInputValue(formattedDate);
      onChange(formattedDate);
    } else {
      setInputValue('');
      onChange('');
    }
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const onBlur = () => {
    if (!inputValue) return;
    const utcDate = new Date(`${inputValue}T00:00:00`);
    const epochUtcDate = utcDate.getTime();

    if (isNaN(epochUtcDate)) {
      setInputValue('');
      onChange('');
    } else {
      onChange(epochUtcDate);
    }
  };

  return (
    <Wrapper>
      <Title required={ required }>
        {title}
      </Title>
      <Container>
        <ReactDatePicker
          selected={ inputValue ? new Date(`${inputValue}T00:00:00`) : null }
          onChange={ handleChange }
          onCalendarClose={ onBlur }
          dateFormat="yyyy-MM-dd"
          placeholderText="YYYY-MM-DD"
        />
      </Container>
    </Wrapper>
  );
};

export default DateInput;
